export default __webpack_public_path__ + "static/underline-23-mobile-3f9505ce341ee6e685c32bc67f5b9874.svg";